import React, { useState, useEffect } from "react";

const AlignTag = ({ setSelectedTags, TagData }) => {
  const [data, setData] = useState([]);
  const [selectedChildTags, setSelectedChildTags] = useState([]);
  const [selectedTagsArray, setSelectedTagsArray] = useState([]);

  const handleChildTagToggle = (parentID, childTag) => {
    setSelectedChildTags((prevSelectedTags) => {
      const tagIndex = prevSelectedTags.findIndex(
        ({ parentID: prevParentID, childTag: prevChildTag }) =>
          prevParentID === parentID && prevChildTag === childTag
      );

      if (tagIndex !== -1) {
        // Remove the entry if it exists
        const updatedSelectedTags = [
          ...prevSelectedTags.slice(0, tagIndex),
          ...prevSelectedTags.slice(tagIndex + 1),
        ];
        setSelectedTagsArray(updatedSelectedTags);
        return updatedSelectedTags;
      } else {
        // Add the entry if it doesn't exist
        const updatedSelectedTags = [...prevSelectedTags, { parentID, childTag }];
        setSelectedTagsArray(updatedSelectedTags);
        return updatedSelectedTags;
      }
    });
  };

  useEffect(() => {
    if (TagData && TagData.length > 0) {
      setData(TagData);
    }
  }, [TagData]);

  useEffect(() => {
    // Extracting only child tag IDs to pass to setSelectedTags
    // const childTagIDs = selectedChildTags.map(({ childTag }) => childTag);
    setSelectedTags(selectedTagsArray);
  }, [selectedChildTags, setSelectedTags]);

  return (
    <>
      <label>Align Tags</label>
      <div className="aligntag mb-3">
        {data.map((obj) => (
          <div className="py-2" key={obj._id}>
            <label>{obj.name}</label>
            <div>
              {obj.child_tags.map((childTag) => (
                <div className="d-flex align-items-center" key={childTag._id}>
                  <input
                    type="checkbox"
                    id={`${obj._id}_${childTag.name}`}
                    checked={selectedChildTags.some(
                      ({ parentID, childTag: selectedChildTag }) =>
                        parentID === obj._id && selectedChildTag === childTag._id
                    )}
                    onChange={() => {
                      handleChildTagToggle(obj._id, childTag._id);
                    }}
                  />
                  <label
                    className="mb-0"
                    style={{ marginLeft: "5px" }}
                    htmlFor={`${obj._id}_${childTag.name}`}>
                    {childTag.name}
                  </label>
                  <br />
                </div>
              ))}
            </div>
          </div>
        ))}
        <div></div>
      </div>
    </>
  );
};

export default AlignTag;
